export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAABCAYAAAB35kaxAAAAAXNSR0IArs4c6QAAABJJREFUCB1jYJJz+M8ABEOZBgALISJImS0XWQAAAABJRU5ErkJggg=="